import { Button, Card, CardActions, CardContent, CardMedia, Typography } from "@mui/material";
import { Link as RouterLink } from 'react-router-dom';

const ProgramCard = ({program,type})=>{



    return (
        <>
        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', boxShadow: 3 }}>
            <CardMedia
                component="img"
                height="160"
                width={100}
                image={program.imageURL}
                alt={program.program}
            />
            <CardContent sx={{ flexGrow: 1 }}>
            <Typography variant="h6" component="h3" align="center" gutterBottom>
                {program.program}
            </Typography>
            
            </CardContent>
            <CardActions>
            <Button
                fullWidth
                size="medium"
                variant="contained"
                color="primary"
                component={RouterLink}
                to={"/programs/"+program.id.toString()+"/"+type}
            >
                View More
            </Button>
            </CardActions>
        </Card>
        </>
    );

};

export default ProgramCard;